import { FaTimes, FaTrashAlt, FaPlus, FaMinus } from "react-icons/fa";
import { useCart } from "../context/CartContext";
import startCheckout from "../payment/startCheckout";   // ← add this

export default function CartDrawer({ open, onClose }) {
  const { items, inc, dec, removeItem, clear, total } = useCart();

  const checkout = async () => {
    if (!items.length) return;
    try {
      await startCheckout({
        amount: total, // rupees
        customer: {
          name: "Ratna Vastra Customer",
          email: "customer@example.com",
          phone: "9999999999",
        },
      });
      // Optionally clear cart after success (do it after server verifies in real app)
      // clear();
      onClose?.();
    } catch (e) {
      console.error(e);
      alert("Unable to start checkout. Please try again.");
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div className={`drawer-backdrop ${open ? "show" : ""}`} onClick={onClose} />

      {/* Drawer panel */}
      <aside className={`drawer ${open ? "open" : ""}`}>
        <div className="drawer-head">
          <h3>Your Cart</h3>
          <button className="icon-btn" onClick={onClose} aria-label="Close cart"><FaTimes /></button>
        </div>

        <div className="drawer-body">
          {items.length === 0 ? (
            <div className="empty"><p>Your cart is empty.</p></div>
          ) : (
            items.map(item => (
              <div className="cart-row" key={item.id}>
                <img src={item.image} alt={item.name} />
                <div className="cart-info">
                  <div className="cart-name" title={item.name}>{item.name}</div>
                  <div className="cart-meta"><span className="cart-price">₹{item.price.toLocaleString('en-IN')}</span></div>
                  <div className="qty-row">
                    <button className="qty-btn" onClick={() => dec(item.id)} aria-label="Decrease"><FaMinus /></button>
                    <span className="qty">{item.qty}</span>
                    <button className="qty-btn" onClick={() => inc(item.id)} aria-label="Increase"><FaPlus /></button>
                  </div>
                </div>
                <button className="trash-btn" onClick={() => removeItem(item.id)} aria-label="Remove"><FaTrashAlt /></button>
              </div>
            ))
          )}
        </div>

        <div className="drawer-foot">
          <div className="sum">
            <span>Total</span>
            <strong>₹{total.toLocaleString('en-IN')}</strong>
          </div>
          <div className="actions">
            <button className="btn-secondary" onClick={clear} disabled={!items.length}>Clear</button>
            <button className="btn-primary" onClick={checkout} disabled={!items.length}>Checkout</button>
          </div>
        </div>
      </aside>
    </>
  );
}
